export function removeLottieLoading() {
  document.getElementById("lottieContainer")?.remove();
  document.getElementById("lottie_styles")?.remove();
}
